module.exports = __webpack_public_path__ + "img/icone_imã_vermelho.1fbcfee3.png";